/* eslint-disable no-unused-vars */
/**
 * 单据类型：1: 差旅，2: 会议，3: 培训， 4: 办公用品采购，5：用印，6：公务接待，7：一般事项，8：招标确认，9：通用采购，10：政府购买服务，11：办公设备家具购置
 */
export enum FormType {
  Trip = 1,
  Meeting = 2,
  Training = 3,
  Purchase = 4,
  Seal = 5,
  Reception = 6,
  General = 7,
  TenderConfirmation = 8,
  Common = 9,
  Service = 10,
  Furniture = 11,
  MultipleMeeting = 12,
  MultipleTraining = 13,
  PublicPayment = 14,
  Overtime = 'Overtime',
  Leave = 'Leave',
  BudgetAdjust = 'BudgetAdjust',
  taizouSpecialEquipment = 18,
  purchaseOrder = 19, // 采购单
  carUseService = 21, // 公车服务申请单
}

/**
 * 申请单工作流key值
 */
export const applyWorkFlowKeyMap = {
  [FormType.Trip]: 'Nu7JavvHmDRMa-pDjRUzFK76',
  [FormType.Meeting]: 'FKZ6u4x6JVSceVhvwChsVB89',
  [FormType.Training]: 'UOLZrGoUMYQEyG-URVsEK6ab',
  [FormType.Purchase]: 'dNu4hePivcQU2x3LXDmzvM84',
  [FormType.Seal]: 'vjUhKW5jo3TLSmqt6lVMhO3c',
  [FormType.Reception]: 'omJtjijrqgSN_8M9RbKpBbfa',
  [FormType.General]: 'pFcOQ1ZTfUR4CXoLSKA47G44',
  [FormType.TenderConfirmation]: 'Fte2qZ-G15R8_vUgcCbYMw6f',
  [FormType.Common]: 'fUtXbC5JU5Q7WfvBJn1DKj77',
  [FormType.Service]: 'AXpAkQJkfET6iuw1-pyGUu0e',
  [FormType.Furniture]: 'VSk819w_bMS1W0kG6W7Fz53b',
  [FormType.Overtime]: 'LCIE-sPBWPRem7CUKHO0Qf01',
  [FormType.Leave]: 'GhJrneT_6CTl6GBtjPgAZu0c',
  [FormType.BudgetAdjust]: 'Fv_yM-4zo9TBOa-Igck8yW5a',
  [FormType.taizouSpecialEquipment]: 'hdplmK4nxmS-_QaF9M-X_M89',
  [FormType.purchaseOrder]: 'pfaqIQ7Ao_Q9yE2uQT8X9nc4',
  [FormType.carUseService]: 'FsG7n492zsTxSyKjdao1I5c0',
};

/**
 * 报销单工作流key值
 */
export const expenseWorkFlowKeyMap = {
  [FormType.Trip]: 'gZsmFJQvSOTiCT0mJyBZL819',
  [FormType.Meeting]: 'vUv2Zk5to8R0a86lebEW1F9b',
  [FormType.Training]: 'onbnS-xAaqQAK22Ih-CeKg35',
  [FormType.Purchase]: 'Fls88c6JAISN6qo-HPPULZd2',
  [FormType.Reception]: 'MsYVDas0uZSoS9JgohePY423',
  [FormType.General]: 'ucb7minD-eTGmtgWAe1691e2',
  [FormType.Common]: 'TvjdQyXGeORiiykH76lJCn3c',
  [FormType.Service]: 'Cgp5sFX028QrOjk5PcIXnZc5',
  [FormType.Furniture]: 'Le3j3OzgKnRweYkdWmL8Oy96',
  [FormType.PublicPayment]: 'eLdKqJqH1BTbiNr-hbTTgRd3',
  [FormType.MultipleMeeting]: 'vUv2Zk5to8R0a86lebEW1F9b',
  [FormType.MultipleTraining]: 'onbnS-xAaqQAK22Ih-CeKg35',
  [FormType.carUseService]: 'erb7Isli8oR6_75VO8ZBcl12',
};

/**
 * 工资申报工作流key值
 */
export const SalaryApplyKey = 'cmhJidJZU7Sze76l6dsY2i4d';

/**
 * 工作流formType枚举
 */
export enum WorkFlowFormType {
  /**
   * 申请单
   */
  Apply = 1,
  /**
   * 报销单
   */
  Claim,
  /**
   * 其他单据
   */
  Other,
  /**
   * 工资申报单
   */
  Salary,
}

export const iconImgUrl = {
  arrow: 'https://sitecdn.zcycdn.com/f2e-assets/160bf038-b668-41cd-85ab-bc3c0ec8e273.svg',
  arrow_active: 'https://sitecdn.zcycdn.com/f2e-assets/3855986c-3200-482d-b312-6dbefec6a075.svg',
};
